import { TranslatePipe } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'session-calendar-date',
    templateUrl: './date.component.html',
    styleUrls: ['./date.component.scss'],
    providers: [TranslatePipe],
})
export class SessionCalendarDateComponent implements OnInit {
    private _startDate: string;
    @Output() startDateChange: EventEmitter<string> = new EventEmitter();

    weekStartLabel = '';
    weekEndLabel = '';

    datePickerDate: any;

    ngOnInit(): void {}

    @Input()
    set startDate(startDate: string) {
        if (startDate == this.startDate) {
            return;
        }
        this.updateStartDateAndAllRelatedData(moment(startDate));
    }

    private updateStartDateAndAllRelatedData(startDateMoment): void {
        this._startDate = startDateMoment.format('YYYY-MM-DD');
        this.datePickerDate = {
            year: startDateMoment.get('year'),
            month: startDateMoment.get('month') + 1,
            day: startDateMoment.get('date'),
        };
        this.startDateChange.emit(this.startDate);
        this.updateLabels(startDateMoment);
    }

    get startDate(): string {
        return this._startDate;
    }

    selectPreviousWeek(): void {
        this.updateStartDateWeek(-1);
    }

    selectNextWeek(): void {
        this.updateStartDateWeek(1);
    }

    private updateStartDateWeek(weekDelta: number): void {
        const startDateMoment = moment(this.startDate).add(weekDelta, 'week');
        this.updateStartDateAndAllRelatedData(startDateMoment);
    }

    datePickerDateChange(date: NgbDateStruct) {
        const startDateMoment = moment([
            date.year,
            date.month - 1,
            date.day,
        ]).isoWeekday(1);
        this.updateStartDateAndAllRelatedData(startDateMoment);
    }

    private updateLabels(startDateMoment) {
        this.weekStartLabel = startDateMoment.format('DD MMM');
        this.weekEndLabel = startDateMoment.add(5, 'day').format('DD MMM YYYY');
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/calendar/date/date.component.ts